export default{
  register:{
    Placeholder:{
      loginName:"请输入用户名",
      registTel:"请输入手机号码或邮箱",
      mobileCode:"请输入验证码",
      password:"设置6至20位登录密码",
      confirmPassword:"请再次输入登录密码",
    },
    Button:{
      Agreement:"《买家用户协议》",
      loginSubBtn:'注册',
      getCode:{
        countdown:"获取验证码",
        countdownChange:"s重新获取验证码"
      }
    },
    Checkbox:{
      registerAgree:'勾选代表您同意',
    },
    loginOtherOpts:{
      haveAccuont:"已有账号，",
      href:"立即登录"
    },
    dialog:{
      title:"图形验证码",
      button:"确定",
      placeholder:"请输入图形验证码",
    },
    rules:{
      required:{
        loginName:"请输入用户名",
        registTel:"请输入手机号或邮箱",
        mobileCode:"请输入验证码",
        password:"请输入密码",
        confirmPassword:"请再次输入登录密码"
      },
      validator:{
        loginNameRepeat:"用户名已存在",
        registTelFormat:"请输入正确的手机号码或邮箱",
        registTelRepeat:"手机号已存在",
        confirmPassword:"请输入相同的密码"
      },
      pattern:{
        loginNameFormat:"请输入4-16位数字/字母/下划线组成的用户名",
        passwordFormat:"请输入6-16位数字/字母/下划线组成的密码"
      }
    },
    Message:{
      Agreement:"请勾选买家用户协议"
    },
  }
  
}